import { render, staticRenderFns } from "./courseAuthDetail.vue?vue&type=template&id=24b8c9ea&scoped=true&"
import script from "./courseAuthDetail.vue?vue&type=script&lang=js&"
export * from "./courseAuthDetail.vue?vue&type=script&lang=js&"
import style0 from "./courseAuthDetail.vue?vue&type=style&index=0&id=24b8c9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8c9ea",
  null
  
)

export default component.exports